import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import {
  FONT_BODY,
  FONT_MONO,
  glassCardSx,
  gridLayerSx,
  Reveal,
  SectionHeading,
  TEAL,
} from './LandingKit';

const faqs = [
  {
    panel: 'panel1',
    question:
      'Como faço para entrar em contato com o suporte se eu tiver uma dúvida ou problema?',
    answer: (
      <>
        Você pode entrar em contato com nosso time de suporte enviando um e-mail para&nbsp;
        <Link href="mailto:suporte@drivesync.com.br" sx={{ color: TEAL, fontWeight: 600 }}>
          suporte@drivesync.com.br
        </Link>
        . Estamos aqui para te ajudar o mais rápido possível.
      </>
    ),
  },
  {
    panel: 'panel2',
    question: 'Posso cancelar a assinatura se não atender às minhas expectativas?',
    answer:
      'Sim! Oferecemos uma política de cancelamento sem complicações. Se você não estiver completamente satisfeito, você pode cancelar a assinatura a qualquer momento para um reembolso completo ou troca de plano.',
  },
  {
    panel: 'panel3',
    question: 'O que nos diferencia dos outros no mercado?',
    answer:
      'Dois pontos: você acompanha as coletas ao vivo sem instalar rastreador (usa o celular do motorista), e consulta a operação direto no WhatsApp, sem abrir o sistema. É controle de coleta em tempo real sem o custo e a dor do hardware.',
  },
  {
    panel: 'panel4',
    question: 'O DriveSync é seguro?',
    answer:
      'Sim, nossa plataforma é segura e confiável. Todos os dados são criptografados e armazenados em servidores seguros. Oferecemos criptografia em repouso e em trânsito além de SSL para transferência de dados.',
  },
  {
    panel: 'panel5',
    question: 'Meus dados ficam retidos no DriveSync por quanto tempo?',
    answer:
      'O DriveSync apenas armazena os dados necessários para o funcionamento do sistema. Todos os dados sensíveis são criptografados e armazenados em servidores seguros. Se você cancelar a assinatura, seus dados serão apagados imediatamente.',
  },
];

export default function FAQ() {
  const [expanded, setExpanded] = React.useState([]);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(
      isExpanded ? [...expanded, panel] : expanded.filter((item) => item !== panel),
    );
  };

  return (
    <Box
      id="faq"
      sx={(theme) => ({
        position: 'relative',
        overflow: 'hidden',
        backgroundColor: '#eef3f2',
        ...theme.applyStyles('dark', { backgroundColor: '#05080b' }),
      })}
    >
      <Box aria-hidden sx={gridLayerSx} />
      <Container
        sx={{
          pt: { xs: 4, sm: 12 },
          pb: { xs: 8, sm: 16 },
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: { xs: 4, sm: 7 },
        }}
      >
        <SectionHeading
          overline="DÚVIDAS"
          align="center"
          title="Perguntas Frequentes"
        />
        <Box sx={{ width: '100%', maxWidth: 820, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          {faqs.map((faq, index) => (
            <Reveal key={faq.panel} delay={index * 0.06}>
              <Accordion
                expanded={expanded.includes(faq.panel)}
                onChange={handleChange(faq.panel)}
                disableGutters
                elevation={0}
                square={false}
                sx={(theme) => ({
                  ...glassCardSx(theme),
                  borderRadius: 3,
                  overflow: 'hidden',
                  '&:before': { display: 'none' },
                  '&:hover': { transform: 'none' },
                  '&.Mui-expanded': { borderColor: `${TEAL}66` },
                })}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: TEAL }} />}
                  aria-controls={`${faq.panel}d-content`}
                  id={`${faq.panel}d-header`}
                  sx={{ px: 2.5, py: 0.5, '& .MuiAccordionSummary-content': { gap: 2, alignItems: 'center' } }}
                >
                  <Typography
                    component="span"
                    sx={(theme) => ({
                      fontFamily: FONT_MONO,
                      fontSize: 12,
                      letterSpacing: '0.08em',
                      color: TEAL,
                      ...theme.applyStyles('dark', { color: '#7df0e2' }),
                    })}
                  >
                    {String(index + 1).padStart(2, '0')}
                  </Typography>
                  <Typography
                    component="span"
                    sx={(theme) => ({
                      fontFamily: FONT_BODY,
                      fontWeight: 600,
                      fontSize: '1rem',
                      color: '#071513',
                      ...theme.applyStyles('dark', { color: '#f2fbf9' }),
                    })}
                  >
                    {faq.question}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ px: 2.5, pb: 2.5, pt: 0, pl: { xs: 2.5, sm: 6 } }}>
                  <Typography
                    sx={(theme) => ({
                      fontFamily: FONT_BODY,
                      fontSize: '0.95rem',
                      lineHeight: 1.6,
                      maxWidth: { sm: '100%', md: '85%' },
                      color: '#33514c',
                      ...theme.applyStyles('dark', { color: '#9fc4bd' }),
                    })}
                  >
                    {faq.answer}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </Reveal>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
